import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Select, Button, Table, Modal, InputNumber } from 'antd'
import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { deleteFile, deleteFile_ALL } from 'api/Project/project'
import { CloseCircleOutlined } from '@ant-design/icons'
import { getCookie } from 'helper/cookie'
import lang from 'lang/en'
import { checkboxTaskDone } from 'api/TaskInbox/checklist'
import { render } from '@testing-library/react'

const initalState = {
  data: [],
  isLoading: true,
}

const DeleteFile = (props) => {
  const {
    visibleDelete,
    setVisibleDelete,
    idDelete,
    project_id,
    kind,
    renderData,
    clearListFile,
    lastFileDelete,
    sprintflow_id,
    taskBoxId,
    state,
    getCheckList,
    getLogList,
    setCheckDelete,
    eventDelete,
    dataSelect,
    dataBox,
    titleText,
    subtitleText,
    setCountFile,
    dataFileInformation,
    setCheckedState,
    setListfile_checkrepeat,
  } = props
  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const handleDeleteFile_Information = () => {
    dataSelect.map((item) => {
      const data = {
        id: item.id,
        project_id: project_id,
        kind: kind,
      }
      try {
        deleteFile({
          params: data,
          token: token,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleDelete(false)
            renderData()
            setCountFile(0)
            setCheckedState(new Array(dataFileInformation.length).fill(false))
          }
        })
      } catch (error) {
        console.log(error)
      }
    })
  }

  const handleDelete = () => {
    let data = {}
    if (eventDelete === 'customfile') {
      if (state === 'information') {
        handleDeleteFile_Information()
      } else {
        dataSelect.map((item) => {
          if (item.task_id === dataBox.id) {
            data = {
              id: item.id,
              project_id: dataBox.project_id,
              kind: item.kind,
            }
            console.log(data)
            try {
              deleteFile({
                params: data,
                token: token,
              }).then((response) => {
                if (response.status === 200) {
                  setVisibleDelete(false)
                  setCheckDelete(true)
                  getLogList()
                  // unCheckDone()
                  setCheckDelete(true)
                }
              })
            } catch (error) {
              console.log(error)
            }
          }
        })
      }
    } else if (eventDelete === 'allfile') {
      if (state === 'checklist') {
        data = {
          project_id: dataBox.project_id,
          kind: dataBox.checklist_type_id,
          sprintflow_id: dataBox.sprintflow_id,
          task_id: dataBox.id,
        }
      } else {
        data = {
          project_id: project_id,
          kind: kind,
          sprintflow_id: '',
          task_id: '',
        }
      }

      try {
        deleteFile_ALL({
          params: data,
          token: token,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleDelete(false)
            if (state === 'checklist') {
              getLogList()
              // unCheckDone()
              setCheckDelete(true)
              setCheckDelete(true)
              setListfile_checkrepeat([])
            } else {
              renderData()
            }
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  // const unCheckDone = () => {
  //   if (lastFileDelete === true) {
  //     const data = {
  //       id: dataBox.id,
  //       project_id: dataBox.project_id,
  //       sprintflow_id: dataBox.sprintflow_id,
  //       done: 'N',
  //     }
  //     try {
  //       checkboxTaskDone({
  //         params: data,
  //         token: token,
  //       }).then((response) => {
  //         if (response.status === 200) {
  //           getCheckList()
  //           getLogList()
  //         }
  //       })
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   }
  // }
  return (
    <Modal
      maskClosable={false}
      className="DeleteModal"
      visible={visibleDelete}
      okText={'Delete'}
      onOk={() => handleDelete()}
      onCancel={() => setVisibleDelete(false)}
    >
      <CloseCircleOutlined className="CloseCircleOutlined" />
      {/* <h2>{word['Upload_listfile_delete_title']}</h2> */}
      <h2>{titleText}</h2>
      {/* <h4>{word['Upload_listfile_delete_des']}</h4> */}
      <h4>{subtitleText}</h4>
    </Modal>
  )
}
export default DeleteFile
